import { render, staticRenderFns } from "./_cookie-appearance-templates.vue?vue&type=template&id=b0a6d866"
import script from "./_cookie-appearance-templates.vue?vue&type=script&lang=js"
export * from "./_cookie-appearance-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports